import { authorizedApi } from './index';

export const notificationsApi = authorizedApi.injectEndpoints({
  endpoints: (builder) => ({
    getCurrentGiveAway: builder.query({
      query: () => '/giveaways/current',
    }),
    joinGiveAway: builder.mutation({
      query: ({ giveAwayId }) => ({
        url: `/giveaways/${giveAwayId}/join`,
        method: 'POST',
      }),
    }),
  }),
  overrideExisting: false,
});

export const { useGetCurrentGiveAwayQuery, useJoinGiveAwayMutation } =
  notificationsApi;
